(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var carousels = document.querySelectorAll('[data-announcement-carousel]');
    carousels.forEach(function (carousel) {
      var slides = carousel.querySelectorAll('.announcement-bar__slide');
      if (slides.length < 2) return;

      var speed = parseInt(carousel.getAttribute('data-speed'), 10) || 4;
      var current = 0;

      function advance() {
        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
        slides[current].setAttribute('aria-hidden', 'false');
      }

      setInterval(advance, speed * 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    const scrim  = document.getElementById('bm-cart-scrim');
    const drawer = document.getElementById('bm-cart-drawer');

    // Secure HTML escaping helper to prevent XSS
    function escapeHtml(str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    // Focus Trapping and Restoration
    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
    
    function getFocusable(container) {
      return Array.from(container.querySelectorAll(focusableSelector)).filter(function (el) {
        return !el.closest('[inert]') && !el.closest('[aria-hidden="true"]') && getComputedStyle(el).display !== 'none';
      });
    }

    function trapFocus(e, container) {
      var focusable = getFocusable(container);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    let cartTriggerEl = null;
    let qvTriggerEl = null;

    function openCart() {
      drawer.classList.add('is-open');
      scrim.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      scrim.setAttribute('aria-hidden', 'false');
      drawer.removeAttribute('inert');
      document.documentElement.setAttribute('data-cart-open', '');
      
      // Focus first element in drawer
      setTimeout(() => {
        const focusable = getFocusable(drawer);
        if (focusable.length > 0) focusable[0].focus();
      }, 50);
    }

    function closeCart() {
      drawer.classList.remove('is-open');
      scrim.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      scrim.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      document.documentElement.removeAttribute('data-cart-open');
      
      // Restore focus
      if (cartTriggerEl) {
        cartTriggerEl.focus();
        cartTriggerEl = null;
      }
    }

    async function refreshDrawerBody() {
      const cartUrl = (window.themeRoutes ? window.themeRoutes.cart_url : '/cart');
      const res = await fetch(cartUrl + '?sections=cart-drawer');
      if (!res.ok) return;
      const data = await res.json();
      if (data['cart-drawer']) {
        const tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'];
        const newBody = tmp.querySelector('#bm-cart-drawer-body');
        const newFoot = tmp.querySelector('.bm-drawer-foot');
        const body = document.getElementById('bm-cart-drawer-body');
        const foot = drawer.querySelector('.bm-drawer-foot');
        if (newBody && body) body.replaceWith(newBody);
        if (foot) foot.remove();
        if (newFoot) drawer.appendChild(newFoot);
        
        // Performance (P5): Extract the cart count from the custom data attribute on newBody to avoid a second network request
        const count = newBody ? parseInt(newBody.dataset.cartCount, 10) : 0;
        updateBagCount(count);
      }
    }

    async function updateBagCount(count) {
      try {
        // Fallback if called without parameters
        if (count === undefined) {
          const res = await fetch('/cart.js');
          if (!res.ok) return;
          const cart = await res.json();
          count = cart.item_count;
        }

        const curCount = document.querySelector('.bm-topnav-bag-count');
        const bagBtn = document.querySelector('[data-open-cart]');

        if (count > 0) {
          if (curCount) {
            curCount.textContent = count;
            curCount.setAttribute('aria-label', count);
          } else if (bagBtn) {
            const span = document.createElement('span');
            span.className = 'bm-topnav-bag-count';
            span.setAttribute('aria-label', count);
            span.textContent = count;
            bagBtn.appendChild(span);
          }
        } else if (curCount) {
          curCount.remove();
        }
      } catch (err) {
        console.error('Error updating bag count:', err);
      }
    }

    async function handleAddToCart(e) {
      const form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();

      const btn = form.querySelector('.bm-pdp-add-btn, [type="submit"]');
      let originalText = '';
      if (btn) {
        originalText = btn.textContent;
        btn.classList.add('is-loading');
        btn.disabled = true;
        btn.style.width = btn.offsetWidth + 'px';
        btn.innerHTML = '<span class="bm-btn-spinner"></span>';
      }

      const data = new FormData(form);
      const addUrl = '/cart/add.js';
      try {
        const res = await fetch(addUrl, { method: 'POST', body: data });
        if (res.ok) {
          await refreshDrawerBody();
          // Open the cart drawer ONLY after the item has been added successfully
          cartTriggerEl = document.activeElement || btn;
          openCart();
        }
      } catch (err) {
        console.error('Error adding item to cart:', err);
      } finally {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          btn.style.width = '';
          btn.textContent = originalText;
        }
      }
    }

    const qtyDebounceTimeouts = {};
    const qtyPendingChanges = {};

    function queueQtyChange(key, qty, lineEl) {
      qtyPendingChanges[key] = qty;

      if (lineEl && qty !== 0) {
        lineEl.style.opacity = '0.7';
      }

      if (qtyDebounceTimeouts[key]) {
        clearTimeout(qtyDebounceTimeouts[key]);
      }

      qtyDebounceTimeouts[key] = setTimeout(async () => {
        const finalQty = qtyPendingChanges[key];
        delete qtyPendingChanges[key];
        delete qtyDebounceTimeouts[key];

        const isRemoving = (finalQty === 0);
        if (isRemoving && lineEl) {
          lineEl.classList.add('is-removing');
          await new Promise(resolve => setTimeout(resolve, 450));
        }

        try {
          const changeUrl = '/cart/change.js';
          const res = await fetch(changeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: finalQty })
          });
          if (res.ok) {
            await refreshDrawerBody();
          } else {
            const errData = await res.json();
            const errMsg = errData.description || errData.message || 'Maximum amount per order reached for this item.';
            showToast(errMsg, true);
            await refreshDrawerBody();
          }
        } catch (err) {
          console.error(err);
          await refreshDrawerBody();
        }
      }, 400);
    }

    async function handleQtyRemove(e) {
      const btn = e.target.closest('[data-qty-remove]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const key = btn.dataset.qtyRemove;
      const lineEl = btn.closest('.bm-line');

      if (lineEl) {
        lineEl.classList.add('is-removing');
        await new Promise(resolve => setTimeout(resolve, 450));
      }

      try {
        const changeUrl = '/cart/change.js';
        const res = await fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        if (res.ok) {
          await refreshDrawerBody();
        } else {
          await refreshDrawerBody();
        }
      } catch (err) {
        console.error(err);
        await refreshDrawerBody();
      }
    }

    function closeAllQtyDrops() {
      document.querySelectorAll('[data-qty-custom-drop]').forEach(drop => {
        const trigger = drop.querySelector('[data-qty-custom-trigger]');
        const panel = drop.querySelector('.bm-qty-custom-panel');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      });
    }

    function handleQtyCustomTrigger(e) {
      const trigger = e.target.closest('[data-qty-custom-trigger]');
      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();

      const drop = trigger.closest('[data-qty-custom-drop]');
      if (!drop) return;

      const panel = drop.querySelector('.bm-qty-custom-panel');
      if (!panel) return;

      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      closeAllQtyDrops();

      if (!isExpanded) {
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        // Focus first option on open for screen readers
        const firstOpt = panel.querySelector('.bm-qty-custom-item');
        if (firstOpt) {
          firstOpt.setAttribute('tabindex', '0');
          firstOpt.focus();
        }
      }
    }

    function handleQtyOptionClick(e) {
      const option = e.target.closest('[data-qty-option]');
      if (!option) return;

      e.preventDefault();
      e.stopPropagation();

      const wrap = option.closest('.bm-qty-selector-wrap');
      const drop = option.closest('[data-qty-custom-drop]');
      const lineEl = option.closest('.bm-line');
      if (!wrap || !drop || !lineEl) return;

      const key = lineEl.dataset.key;
      const val = option.dataset.qtyOption;

      if (val === '10+') {
        const dropContainer = wrap.querySelector('.bm-qty-dropdown-container');
        const inputContainer = wrap.querySelector('.bm-qty-input-container');
        const input = wrap.querySelector('.bm-qty-input-field');

        if (dropContainer) dropContainer.style.display = 'none';
        if (inputContainer) inputContainer.style.display = 'inline-flex';
        if (input) {
          input.value = 10;
          input.focus();
          input.select();
        }

        queueQtyChange(key, 10, lineEl);
      } else {
        const qty = parseInt(val, 10);
        const trigger = drop.querySelector('[data-qty-custom-trigger]');
        const panel = drop.querySelector('.bm-qty-custom-panel');

        if (trigger) {
          const span = trigger.querySelector('span');
          if (span) span.textContent = qty;
          trigger.setAttribute('aria-expanded', 'false');
        }
        if (panel) panel.hidden = true;

        queueQtyChange(key, qty, lineEl);
        if (trigger) trigger.focus();
      }
    }

    // Keyboard behavior for quantity custom dropdown (A5)
    function handleQtyCustomKeydown(e) {
      const trigger = e.target.closest('[data-qty-custom-trigger]');
      if (trigger) {
        const drop = trigger.closest('[data-qty-custom-drop]');
        if (!drop) return;
        const panel = drop.querySelector('.bm-qty-custom-panel');
        const items = Array.from(drop.querySelectorAll('.bm-qty-custom-item'));
        
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          trigger.setAttribute('aria-expanded', 'true');
          if (panel) panel.hidden = false;
          
          const focusTarget = (e.key === 'ArrowUp') ? items[items.length - 1] : items[0];
          if (focusTarget) {
            items.forEach(el => el.setAttribute('tabindex', '-1'));
            focusTarget.setAttribute('tabindex', '0');
            focusTarget.focus();
          }
        } else if (e.key === 'Escape') {
          trigger.setAttribute('aria-expanded', 'false');
          if (panel) panel.hidden = true;
        }
        return;
      }

      const item = e.target.closest('.bm-qty-custom-item');
      if (item) {
        const drop = item.closest('[data-qty-custom-drop]');
        if (!drop) return;
        const trigger = drop.querySelector('[data-qty-custom-trigger]');
        const panel = drop.querySelector('.bm-qty-custom-panel');
        const items = Array.from(drop.querySelectorAll('.bm-qty-custom-item'));
        const idx = items.indexOf(item);

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const next = items[idx + 1] || items[0];
          items.forEach(el => el.setAttribute('tabindex', '-1'));
          next.setAttribute('tabindex', '0');
          next.focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          const prev = items[idx - 1] || items[items.length - 1];
          items.forEach(el => el.setAttribute('tabindex', '-1'));
          prev.setAttribute('tabindex', '0');
          prev.focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.click();
        } else if (e.key === 'Escape' || e.key === 'Tab') {
          trigger.setAttribute('aria-expanded', 'false');
          if (panel) panel.hidden = true;
          trigger.focus();
        }
      }
    }

    async function handleInputChange(e) {
      const input = e.target.closest('[data-qty-input]');
      if (!input) return;

      const lineEl = input.closest('.bm-line');
      if (!lineEl) return;

      const key = lineEl.dataset.key;
      let qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;

      queueQtyChange(key, qty, lineEl);
    }

    async function handleQtyChange(e) {
      const btn = e.target.closest('[data-qty-change]');
      if (!btn) return;

      const lineEl = btn.closest('.bm-line');
      if (!lineEl) return;

      const key = lineEl.dataset.key;
      const delta = parseInt(btn.dataset.delta, 10);
      const wrap = btn.closest('.bm-qty-selector-wrap');
      if (!wrap) return;

      const qtyEl = wrap.querySelector('.bm-qty-input-field');
      if (!qtyEl) return;

      const current = parseInt(qtyEl.value, 10);

      let targetQty = current + delta;
      if (qtyPendingChanges[key] !== undefined) {
        targetQty = qtyPendingChanges[key] + delta;
      }
      targetQty = Math.max(0, targetQty);

      qtyEl.value = targetQty;
      queueQtyChange(key, targetQty, lineEl);
    }

    function showToast(message, isError = false) {
      const existing = document.querySelector('.bm-toast');
      if (existing) existing.remove();

      const toast = document.createElement('div');
      toast.className = `bm-toast${isError ? ' bm-toast-error' : ''}`;

      // XSS Protection: message is escaped before being inserted as HTML
      if (isError) {
        toast.innerHTML = `
          <span class="bm-toast-icon">✕</span>
          <span style="text-transform: none; letter-spacing: 0.02em; font-size: 12px;">${escapeHtml(message)}</span>
        `;
      } else {
        toast.innerHTML = `
          <span class="bm-toast-icon">✓</span>
          <span>Added <span class="bm-toast-title">“${escapeHtml(message)}”</span> to bag</span>
        `;
      }

      document.body.appendChild(toast);
      toast.offsetHeight; // trigger reflow
      toast.classList.add('is-visible');

      setTimeout(() => {
        toast.classList.remove('is-visible');
        setTimeout(() => {
          toast.remove();
        }, 400);
      }, isError ? 4500 : 3500);
    }

    let currentProduct = null;
    let selectedOptions = {};
    const qvScrim = document.getElementById('bm-quickview-scrim');
    const qvDrawer = document.getElementById('bm-quickview-drawer');

    function openQuickview() {
      if (qvDrawer && qvScrim) {
        qvDrawer.classList.add('is-open');
        qvScrim.classList.add('is-open');
        qvDrawer.setAttribute('aria-hidden', 'false');
        qvScrim.setAttribute('aria-hidden', 'false');
        qvDrawer.removeAttribute('inert');
        document.body.style.overflow = 'hidden';
        
        // Focus first element in quickview drawer
        setTimeout(() => {
          const focusable = getFocusable(qvDrawer);
          if (focusable.length > 0) focusable[0].focus();
        }, 50);
      }
    }

    function closeQuickview() {
      if (qvDrawer && qvScrim) {
        qvDrawer.classList.remove('is-open');
        qvScrim.classList.remove('is-open');
        qvDrawer.setAttribute('aria-hidden', 'true');
        qvScrim.setAttribute('aria-hidden', 'true');
        qvDrawer.setAttribute('inert', '');
        document.body.style.overflow = '';
        currentProduct = null;
        
        // Restore focus
        if (qvTriggerEl) {
          qvTriggerEl.focus();
          qvTriggerEl = null;
        }
      }
    }

    function renderQuickview(product) {
      currentProduct = product;
      selectedOptions = {};
      
      const firstAvailable = product.variants.find(v => v.available) || product.variants[0];
      product.options.forEach((opt, index) => {
        selectedOptions[opt.name] = firstAvailable ? firstAvailable[`option${index + 1}`] : opt.values[0];
      });

      const body = document.getElementById('bm-quickview-body');
      if (!body) return;

      const currentVariant = findCurrentVariant();
      const formattedPrice = formatMoney(currentVariant ? currentVariant.price : product.price);

      let optionsHTML = '';
      product.options.forEach((opt, optIndex) => {
        if (opt.values.length > 1 || opt.name !== 'Title') {
          optionsHTML += `
            <div class="bm-qv-option-group" data-option-index="${optIndex}">
              <div class="bm-qv-option-label">${escapeHtml(opt.name)}</div>
              <div class="bm-qv-pills">
                ${opt.values.map(val => {
                  const isActive = selectedOptions[opt.name] === val;
                  return `
                    <button type="button" class="bm-qv-pill${isActive ? ' is-active' : ''}" data-opt-name="${escapeHtml(opt.name)}" data-opt-val="${escapeHtml(val)}">
                      ${escapeHtml(val)}
                    </button>
                  `;
                }).join('')}
              </div>
            </div>
          `;
        }
      });

      const featuredImage = product.featured_image || '';
      
      // XSS Protection: escapeHtml used for all dynamic product strings to prevent HTML injections
      body.innerHTML = `
        <div class="bm-qv-product">
          <div class="bm-qv-meta">
            ${featuredImage ? `<img src="${escapeHtml(featuredImage)}" alt="${escapeHtml(product.title)}" class="bm-qv-img">` : '<div class="bm-qv-img" style="background:#eee;"></div>'}
            <div class="bm-qv-details">
              <div class="bm-qv-title">${escapeHtml(product.title)}</div>
              <div class="bm-qv-price" id="bm-qv-price-val">${escapeHtml(formattedPrice)}</div>
            </div>
          </div>
          
          <div class="bm-qv-options">
            ${optionsHTML}
          </div>

          <div class="bm-qv-submit-wrap">
            <button type="button" class="bm-qv-submit" id="bm-qv-add-btn" ${(!currentVariant || !currentVariant.available) ? 'disabled' : ''}>
              ${(currentVariant && currentVariant.available) ? 'Add to Bag' : 'Sold Out'}
            </button>
          </div>
        </div>
      `;
    }

    function findCurrentVariant() {
      if (!currentProduct) return null;
      return currentProduct.variants.find(v => {
        return currentProduct.options.every((opt, index) => {
          return v[`option${index + 1}`] === selectedOptions[opt.name];
        });
      });
    }

    function formatMoney(cents) {
      const dollars = (cents / 100).toFixed(2);
      const symbol = window.themeCurrencySymbol || '$';
      return symbol + dollars;
    }

    function updateQuickviewState() {
      const btn = document.getElementById('bm-qv-add-btn');
      const priceVal = document.getElementById('bm-qv-price-val');
      if (!btn || !currentProduct) return;

      const variant = findCurrentVariant();
      if (variant) {
        if (priceVal) priceVal.textContent = formatMoney(variant.price);
        if (variant.available) {
          btn.textContent = 'Add to Bag';
          btn.removeAttribute('disabled');
        } else {
          btn.textContent = 'Sold Out';
          btn.setAttribute('disabled', 'true');
        }
      } else {
        btn.textContent = 'Unavailable';
        btn.setAttribute('disabled', 'true');
      }
    }

    function handleQvPillClick(e) {
      const pill = e.target.closest('.bm-qv-pill');
      if (!pill) return;

      e.preventDefault();
      e.stopPropagation();

      const name = pill.dataset.optName;
      const val = pill.dataset.optVal;
      const group = pill.closest('.bm-qv-option-group');
      if (!group || !name || !val) return;

      selectedOptions[name] = val;

      group.querySelectorAll('.bm-qv-pill').forEach(btn => {
        btn.classList.remove('is-active');
      });
      pill.classList.add('is-active');

      updateQuickviewState();
    }

    async function handleQvSubmit(e) {
      const btn = e.target.closest('#bm-qv-add-btn');
      if (!btn || btn.disabled) return;

      e.preventDefault();
      e.stopPropagation();

      const variant = findCurrentVariant();
      if (!variant) return;

      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        });
        if (res.ok) {
          await refreshDrawerBody();
          const productTitle = currentProduct ? currentProduct.title : 'Product';
          closeQuickview();
          showToast(productTitle);
          
          // Open the cart drawer
          cartTriggerEl = qvTriggerEl;
          openCart();
        } else {
          showToast('Error adding item.', true);
          btn.textContent = originalText;
          btn.disabled = false;
        }
      } catch (err) {
        console.error(err);
        showToast('Error adding item.', true);
        btn.textContent = originalText;
        btn.disabled = false;
      }
    }

    async function handleQuickAdd(e) {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const hasOptions = btn.dataset.hasOptions === 'true';
      const handle = btn.dataset.productHandle;

      if (hasOptions && handle) {
        qvTriggerEl = btn;
        const body = document.getElementById('bm-quickview-body');
        if (body) {
          body.innerHTML = `
            <div style="display:flex; justify-content:center; align-items:center; padding:120px 0;">
              <span class="bm-btn-spinner" style="width:24px; height:24px; border-width:3px; border-top-color:var(--color-burgundy);"></span>
            </div>
          `;
        }
        openQuickview();

        try {
          const res = await fetch(`/products/${handle}.js`);
          if (res.ok) {
            const product = await res.json();
            renderQuickview(product);
          } else {
            closeQuickview();
            showToast('Unable to load product options.', true);
          }
        } catch (err) {
          console.error(err);
          closeQuickview();
          showToast('Unable to load product options.', true);
        }
        return;
      }

      const variantId = btn.dataset.variantId;
      const productTitle = btn.dataset.productTitle || 'Product';
      if (!variantId) return;

      const originalText = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = `<span class="bm-btn-spinner"></span>Adding...`;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });

        if (res.ok) {
          btn.innerHTML = `✓ Added`;
          showToast(productTitle);
          await refreshDrawerBody();
          
          setTimeout(() => {
            btn.innerHTML = originalText;
            btn.disabled = false;
          }, 2000);
        } else {
          const errData = await res.json();
          if (errData.status === 422) {
            btn.innerHTML = `Limit reached`;
            showToast(errData.description || 'All available stock is in your bag.', true);
            setTimeout(() => {
              btn.innerHTML = originalText;
              btn.disabled = false;
            }, 2000);
          } else {
            btn.innerHTML = `Error`;
            showToast(errData.description || 'Error adding item.', true);
            setTimeout(() => {
              btn.innerHTML = originalText;
              btn.disabled = false;
            }, 2000);
          }
        }
      } catch (err) {
        console.error(err);
        btn.innerHTML = `Error`;
        showToast('Error adding item.', true);
        setTimeout(() => {
          btn.innerHTML = originalText;
          btn.disabled = false;
        }, 2000);
      }
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-cart]')) {
        cartTriggerEl = e.target.closest('[data-open-cart]');
        openCart();
        return;
      }
      if (e.target.closest('[data-close-cart]')) { closeCart(); return; }
      if (e.target === scrim) { closeCart(); return; }
      if (e.target.closest('[data-close-quickview]')) { closeQuickview(); return; }
      if (e.target === qvScrim) { closeQuickview(); return; }
    });

    document.addEventListener('submit', handleAddToCart);
    document.addEventListener('click', handleQtyChange);
    document.addEventListener('click', handleQuickAdd);
    document.addEventListener('click', handleQtyCustomTrigger);
    document.addEventListener('click', handleQtyOptionClick);
    document.addEventListener('click', handleQtyRemove);
    document.addEventListener('click', function(e) {
      if (!e.target.closest('[data-qty-custom-drop]')) {
        closeAllQtyDrops();
      }
    });
    document.addEventListener('click', handleQvPillClick);
    document.addEventListener('click', handleQvSubmit);
    document.addEventListener('change', handleInputChange);
    document.addEventListener('focusout', function(e) {
      if (e.target.matches('[data-qty-input]')) {
        handleInputChange(e);
      }
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && e.target.matches('[data-qty-input]')) {
        e.preventDefault();
        e.target.blur();
      }
    });

    document.addEventListener('keydown', handleQtyCustomKeydown);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeCart();
        closeQuickview();
      }
      if (e.key === 'Tab') {
        if (drawer.classList.contains('is-open')) {
          trapFocus(e, drawer);
        } else if (qvDrawer && qvDrawer.classList.contains('is-open')) {
          trapFocus(e, qvDrawer);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    /* Desktop Sidebar Toggle */
    var desktopFilterToggle = document.querySelector('[data-desktop-filter-toggle]');
    var desktopFilterClose = document.querySelector('[data-desktop-filter-close]');
    var desktopSidebar = document.getElementById('bm-desktop-sidebar');

    if (desktopFilterToggle && desktopSidebar) {
      desktopFilterToggle.addEventListener('click', function() {
        if (desktopSidebar.hasAttribute('hidden')) {
          desktopSidebar.removeAttribute('hidden');
        } else {
          desktopSidebar.setAttribute('hidden', '');
        }
      });
    }
    if (desktopFilterClose && desktopSidebar) {
      desktopFilterClose.addEventListener('click', function() {
        desktopSidebar.setAttribute('hidden', '');
      });
    }

    /* Desktop Sort Dropdown */
    var sortTrigger = document.querySelector('[data-sort-trigger]');
    var sortPanel = document.querySelector('.bm-sort-panel');

    if (sortTrigger && sortPanel) {
      sortTrigger.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = sortTrigger.getAttribute('aria-expanded') === 'true';
        closeAllDrops();
        if (!isOpen) {
          sortTrigger.setAttribute('aria-expanded', 'true');
          sortPanel.hidden = false;
        }
      });
      sortPanel.addEventListener('click', function(e) { e.stopPropagation(); });
    }

    function closeAllDrops() {
      if (sortTrigger) sortTrigger.setAttribute('aria-expanded', 'false');
      if (sortPanel) sortPanel.hidden = true;
    }

    document.addEventListener('click', closeAllDrops);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeAllDrops();
    });

    /* Mobile sheets */
    var overlay = document.querySelector('[data-sheet-overlay]');
    var activeSheet = null;

    function openSheet(sheet, triggerBtn) {
      if (activeSheet) closeSheet();
      activeSheet = sheet;
      sheet.classList.add('is-open');
      sheet.removeAttribute('aria-hidden');
      sheet.removeAttribute('inert');
      if (overlay) {
        overlay.classList.add('is-open');
        overlay.removeAttribute('aria-hidden');
      }
      if (triggerBtn) triggerBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeSheet() {
      if (!activeSheet) return;
      if (activeSheet.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      var sheetToClose = activeSheet;
      sheetToClose.classList.remove('is-open');
      sheetToClose.setAttribute('aria-hidden', 'true');
      sheetToClose.setAttribute('inert', '');
      if (overlay) {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
      }
      document.querySelectorAll('[data-open-filters],[data-open-sort]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      document.body.style.overflow = '';
      activeSheet = null;
    }

    var openFilterBtn = document.querySelector('[data-open-filters]');
    var openSortBtn   = document.querySelector('[data-open-sort]');
    var filterSheet   = document.getElementById('bm-filter-sheet');
    var sortSheet     = document.getElementById('bm-sort-sheet');

    if (openFilterBtn && filterSheet) {
      openFilterBtn.addEventListener('click', function () { openSheet(filterSheet, openFilterBtn); });
    }
    if (openSortBtn && sortSheet) {
      openSortBtn.addEventListener('click', function () { openSheet(sortSheet, openSortBtn); });
    }

    document.querySelectorAll('[data-close-sheet]').forEach(function (btn) {
      btn.addEventListener('click', closeSheet);
    });

    if (overlay) overlay.addEventListener('click', closeSheet);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSheet();
    });

    /* Infinite Scroll Lazy Loader */
    var productsGrid = document.querySelector('[data-products-grid]');
    var paginationContainer = document.querySelector('[data-pagination]');
    
    if (productsGrid && paginationContainer) {
      // Hide standard pagination visually
      paginationContainer.style.display = 'none';

      // Create Sentinel element right after pagination
      var sentinel = document.createElement('div');
      sentinel.id = 'bm-infinite-sentinel';
      sentinel.style.height = '20px';
      sentinel.style.width = '100%';
      sentinel.style.clear = 'both';
      productsGrid.parentNode.insertBefore(sentinel, paginationContainer.nextSibling);

      var isLoading = false;

      function getNextPageUrl() {
        var nextLink = paginationContainer.querySelector('.next a');
        return nextLink ? nextLink.href : null;
      }

      function getSkelTemplate() {
        var skel = document.createElement('div');
        skel.className = 'bm-pc bm-pc-skeleton';
        skel.innerHTML = `
          <div class="bm-pc-image bm-skeleton-pulse"></div>
          <div class="bm-pc-name-skeleton bm-skeleton-pulse"></div>
          <div class="bm-pc-sub-skeleton bm-skeleton-pulse"></div>
          <div class="bm-pc-price-skeleton bm-skeleton-pulse"></div>
        `;
        return skel;
      }

      function loadNextPage() {
        var nextUrl = getNextPageUrl();
        if (!nextUrl || isLoading) return;

        isLoading = true;

        // Append 4 skeleton cards to the grid
        var skels = [];
        for (var i = 0; i < 4; i++) {
          var skel = getSkelTemplate();
          productsGrid.appendChild(skel);
          skels.push(skel);
        }

        // Fetch the next page HTML
        fetch(nextUrl)
          .then(function (response) {
            return response.text();
          })
          .then(function (htmlText) {
            // Remove skeleton loaders
            skels.forEach(function (skel) {
              if (skel.parentNode) skel.parentNode.removeChild(skel);
            });

            // Parse fetched HTML
            var parser = new DOMParser();
            var doc = parser.parseFromString(htmlText, 'text/html');

            // Find new products
            var newProducts = doc.querySelectorAll('[data-products-grid] .bm-pc');
            newProducts.forEach(function (product) {
              productsGrid.appendChild(product);
            });

            // Update active pagination container
            var newPagination = doc.querySelector('[data-pagination]');
            if (newPagination) {
              paginationContainer.innerHTML = newPagination.innerHTML;
            } else {
              paginationContainer.innerHTML = '';
            }

            isLoading = false;

            // If no next page exists, disconnect sentinel observer
            if (!getNextPageUrl()) {
              observer.disconnect();
              if (sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
            }
          })
          .catch(function (error) {
            console.error('Error loading next page:', error);
            // Remove skeletons on error
            skels.forEach(function (skel) {
              if (skel.parentNode) skel.parentNode.removeChild(skel);
            });
            isLoading = false;
          });
      }

      // Use Intersection Observer for highly performant scroll detection
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadNextPage();
          }
        });
      }, {
        rootMargin: '200px', // Preload ahead of time for smooth continuous scrolling
        threshold: 0.1
      });

      observer.observe(sentinel);
    }

    /* Unobtrusive filter/sort auto-submit — replaces inline onchange attributes */
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!el.dataset || !el.dataset.autoSubmitForm) return;
      var form = document.getElementById(el.dataset.autoSubmitForm);
      if (form) form.submit();
    });

    /* Progressive Disclosure for Collection Description */
    var descWrapper = document.querySelector('.bm-collection-desc-wrapper');
    var descContent = document.querySelector('[data-desc-content]');
    var descToggle = document.querySelector('[data-desc-toggle]');

    if (descWrapper && descContent && descToggle) {
      var clampedHeight = 72; // matches max-height in CSS
      
      // Compute actual content heights
      function checkTruncation() {
        if (descContent.scrollHeight > clampedHeight + 10) {
          descWrapper.classList.add('has-truncation');
          descToggle.style.display = 'inline-flex';
          descContent.style.maxHeight = clampedHeight + 'px';
        } else {
          descWrapper.classList.remove('has-truncation');
          descToggle.style.display = 'none';
          descContent.style.maxHeight = 'none';
        }
      }

      // Check on startup
      setTimeout(checkTruncation, 150);
      window.addEventListener('resize', checkTruncation);

      descToggle.addEventListener('click', function() {
        var isExpanded = descWrapper.classList.contains('is-expanded');
        if (isExpanded) {
          descWrapper.classList.remove('is-expanded');
          descContent.classList.remove('is-expanded');
          descToggle.querySelector('.bm-toggle-text').textContent = 'Read More';
          descContent.style.maxHeight = clampedHeight + 'px';
        } else {
          descWrapper.classList.add('is-expanded');
          descContent.classList.add('is-expanded');
          descToggle.querySelector('.bm-toggle-text').textContent = 'Read Less';
          descContent.style.maxHeight = descContent.scrollHeight + 'px';
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var hamburger = document.querySelector('[data-hamburger]');
    var overlay = document.querySelector('[data-nav-overlay]');
    var nav = document.getElementById('bm-mobile-nav');

    if (!hamburger || !overlay || !nav) return;

    var navFocusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function getFocusable(container) {
      return Array.from(container.querySelectorAll(navFocusableSelector)).filter(function (el) {
        return !el.closest('[inert]') && !el.closest('[aria-hidden="true"]') && getComputedStyle(el).display !== 'none';
      });
    }

    function trapFocus(e, container) {
      var focusable = getFocusable(container);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    function openNav() {
      nav.classList.add('is-open');
      overlay.classList.add('is-open');
      nav.removeAttribute('aria-hidden');
      overlay.removeAttribute('aria-hidden');
      nav.removeAttribute('inert');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var firstFocusable = nav.querySelector(navFocusableSelector);
      if (firstFocusable) firstFocusable.focus();
    }

    function closeNav() {
      nav.classList.remove('is-open');
      overlay.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      nav.setAttribute('inert', '');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      hamburger.focus();
    }

    hamburger.addEventListener('click', openNav);
    overlay.addEventListener('click', closeNav);

    var closeBtn = nav.querySelector('[data-close-nav]');
    if (closeBtn) closeBtn.addEventListener('click', closeNav);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNav();
      if (e.key === 'Tab' && nav.classList.contains('is-open')) trapFocus(e, nav);
    });

    // Desktop top-navigation keyboard and hover support
    var dropdownWrappers = document.querySelectorAll('.bm-topnav-dropdown-wrapper');
    dropdownWrappers.forEach(function (wrapper) {
      var trigger = wrapper.querySelector('.bm-topnav-dropdown-trigger');
      var links = Array.from(wrapper.querySelectorAll('.bm-topnav-dropdown-link, .bm-topnav-dropdown .bm-topnav-nested-trigger'));
      if (!trigger) return;

      function openDropdown() {
        trigger.setAttribute('aria-expanded', 'true');
      }

      function closeDropdown() {
        trigger.setAttribute('aria-expanded', 'false');
      }

      // Sync hover state with aria-expanded
      wrapper.addEventListener('mouseenter', openDropdown);
      wrapper.addEventListener('mouseleave', closeDropdown);

      // Support focus/blur transitions
      wrapper.addEventListener('focusin', openDropdown);
      wrapper.addEventListener('focusout', function (e) {
        if (!wrapper.contains(e.relatedTarget)) {
          closeDropdown();
        }
      });

      // Keyboard navigation on the trigger
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          openDropdown();
          var firstLink = links[0];
          if (firstLink) firstLink.focus();
        } else if (e.key === 'Escape') {
          closeDropdown();
        }
      });

      // Keyboard navigation on dropdown links
      links.forEach(function (link, idx) {
        link.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            var next = links[idx + 1] || links[0];
            if (next) next.focus();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            var prev = links[idx - 1] || trigger; // Loop back to trigger
            if (prev) prev.focus();
          } else if (e.key === 'Escape') {
            closeDropdown();
            trigger.focus();
          }
        });
      });
    });

    // Intercept change event on localization select elements to redirect directly
    document.addEventListener('change', function (e) {
      var select = e.target;
      if (!select.dataset || !select.dataset.availableLocales) return;

      var targetLocale = select.value;
      var currentLocale = select.dataset.currentLocale;
      var locales = JSON.parse(select.dataset.availableLocales);

      var targetLang = locales.find(function (l) { return l.code === targetLocale; });
      var currentLang = locales.find(function (l) { return l.code === currentLocale; });

      if (!targetLang || !currentLang) return;

      // Prevent the default form submission to bypass proxy issues
      e.preventDefault();
      e.stopImmediatePropagation();

      var path = window.location.pathname;

      // Sort locales by url length descending
      var sortedLocales = locales.slice().sort(function (a, b) {
        return b.url.length - a.url.length;
      });

      // Strip current locale prefix if it's not root "/"
      for (var i = 0; i < sortedLocales.length; i++) {
        var lang = sortedLocales[i];
        if (lang.url !== '/' && lang.url !== '') {
          if (path.indexOf(lang.url + '/') === 0 || path === lang.url) {
            path = path.substring(lang.url.length);
            if (path.indexOf('/') !== 0) {
              path = '/' + path;
            }
            break;
          }
        }
      }

      // Prepend target locale's url prefix
      var prefix = targetLang.url;
      if (prefix === '/') {
        prefix = '';
      }

      var finalPath = prefix + path;
      if (finalPath === '') {
        finalPath = '/';
      }

      window.location.href = finalPath + window.location.search + window.location.hash;
    });

    // Custom Select Dropdowns Controller (wrapped in DOMContentLoaded to ensure footer selectors are parsed)
    document.addEventListener('DOMContentLoaded', function () {
      const dropdowns = document.querySelectorAll('[data-custom-dropdown]');

      function closeAllDropdowns(except) {
        dropdowns.forEach(function (d) {
          if (d === except) return;
          d.classList.remove('is-open');
          const t = d.querySelector('.bm-custom-dropdown-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }

      dropdowns.forEach(function (dropdown) {
        const trigger = dropdown.querySelector('.bm-custom-dropdown-trigger');
        const menu = dropdown.querySelector('.bm-custom-dropdown-menu');
        const select = dropdown.querySelector('select');
        const triggerLabel = dropdown.querySelector('.bm-custom-dropdown-trigger-label');
        const items = Array.from(dropdown.querySelectorAll('.bm-custom-dropdown-item'));

        if (!trigger || !menu || !select) return;

        // ARIA roles for listbox pattern
        menu.setAttribute('role', 'listbox');
        trigger.setAttribute('aria-haspopup', 'listbox');
        items.forEach(function (item) {
          item.setAttribute('role', 'option');
          item.setAttribute('tabindex', '-1');
        });

        function openDropdown() {
          closeAllDropdowns(dropdown);
          dropdown.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }

        function closeDropdown() {
          dropdown.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }

        function selectItem(item) {
          const value = item.dataset.value;
          select.value = value;
          items.forEach(function (o) {
            o.classList.remove('is-selected');
            o.setAttribute('aria-selected', 'false');
          });
          item.classList.add('is-selected');
          item.setAttribute('aria-selected', 'true');
          const itemFlag = item.querySelector('.bm-custom-dropdown-flag');
          const triggerFlag = dropdown.querySelector('.bm-custom-dropdown-trigger .bm-custom-dropdown-flag');
          if (itemFlag && triggerFlag) triggerFlag.src = itemFlag.src;
          if (triggerLabel) {
            const itemText = item.querySelector('.bm-custom-dropdown-item-text');
            triggerLabel.textContent = itemText ? itemText.textContent.trim() : item.textContent.trim();
          }
          closeDropdown();
          trigger.focus();
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        trigger.addEventListener('click', function (e) {
          e.stopPropagation();
          if (dropdown.classList.contains('is-open')) {
            closeDropdown();
          } else {
            openDropdown();
          }
        });

        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            openDropdown();
            var focusTarget = e.key === 'ArrowDown' ? items[0] : items[items.length - 1];
            if (focusTarget) focusTarget.focus();
          } else if (e.key === 'Escape') {
            closeDropdown();
          }
        });

        items.forEach(function (item, idx) {
          item.addEventListener('click', function (e) {
            e.stopPropagation();
            selectItem(item);
          });

          item.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowDown') {
              e.preventDefault();
              (items[idx + 1] || items[0]).focus();
            } else if (e.key === 'ArrowUp') {
              e.preventDefault();
              (items[idx - 1] || items[items.length - 1]).focus();
            } else if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              selectItem(item);
            } else if (e.key === 'Escape' || e.key === 'Tab') {
              closeDropdown();
              trigger.focus();
            }
          });
        });
      });

      document.addEventListener('click', function () {
        dropdowns.forEach(function (d) {
          d.classList.remove('is-open');
          const t = d.querySelector('.bm-custom-dropdown-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const form = document.getElementById('bm-pdp-form');
    if (!form) return;

    const variantIdInput = document.getElementById('bm-pdp-variant-id');
    const priceEl = document.getElementById('bm-pdp-price');
    const addBtn = form.querySelector('.bm-pdp-add-btn');
    const variantsEl = document.getElementById('bm-pdp-variants-json');
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    
    const variantPricesEl = document.getElementById('bm-pdp-variant-prices');
    const variantPrices = variantPricesEl ? JSON.parse(variantPricesEl.textContent) : {};

    let selectedOptions = {};

    function getSelectedVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selectedOptions[i + 1] === opt;
        });
      });
    }

    function updateVariant() {
      const v = getSelectedVariant();
      if (!v) return;
      variantIdInput.value = v.id;
      
      const vPrice = variantPrices[v.id];
      if (priceEl && vPrice) {
        priceEl.textContent = vPrice.price;
        const comparePriceEl = document.getElementById('bm-pdp-compare-price');
        if (comparePriceEl) {
          if (v.compare_at_price > v.price) {
            comparePriceEl.textContent = vPrice.compare_at_price;
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
      }
      
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available
          ? addBtn.dataset.labelAvailable
          : addBtn.dataset.labelSoldOut;
      }

      // Synchronize sticky add to cart bar values
      const stickyVariantLabel = document.getElementById('bm-sticky-cart-variant-label');
      const stickyPriceLabel = document.getElementById('bm-sticky-cart-price-label');
      const stickySubmit = document.getElementById('bm-sticky-cart-submit');
      const stickyImg = document.getElementById('bm-sticky-cart-img');
      
      if (stickyVariantLabel) {
        stickyVariantLabel.textContent = (v.title === 'Default Title' || v.title === 'Default title') ? '' : v.title;
      }
      if (stickyPriceLabel && vPrice) stickyPriceLabel.textContent = vPrice.price;
      if (stickySubmit) {
        stickySubmit.disabled = !v.available;
        stickySubmit.textContent = v.available ? addBtn.dataset.labelAvailable : addBtn.dataset.labelSoldOut;
      }
      if (stickyImg && v.featured_image) {
        const targetImg = document.querySelector('.bm-pdp-gallery-item[data-image-id="' + v.featured_image.id + '"] img');
        if (targetImg) {
          stickyImg.src = targetImg.src;
        }
      }
      
      if (v.featured_image && v.featured_image.id) {
        const targetImage = document.querySelector('.bm-pdp-gallery-item[data-image-id="' + v.featured_image.id + '"]');
        if (targetImage) {
          targetImage.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
      
      history.replaceState({}, '', '?variant=' + v.id);
    }

    // Intercept clicks on pills and color swatches
    form.querySelectorAll('.bm-pdp-pill, .bm-pdp-color-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const pos = parseInt(btn.dataset.option, 10);
        const val = btn.dataset.value;
        selectedOptions[pos] = val;

        // Toggle selected classes
        form.querySelectorAll('[data-option-position="' + pos + '"] .bm-pdp-pill, [data-option-position="' + pos + '"] .bm-pdp-color-swatch')
          .forEach(function (b) { b.classList.toggle('is-selected', b.dataset.value === val); });

        const selectedLabel = document.getElementById('bm-pdp-option-' + pos + '-selected');
        if (selectedLabel) selectedLabel.textContent = val;

        updateVariant();
      });
    });

    form.querySelectorAll('.bm-pdp-pill.is-selected, .bm-pdp-color-swatch.is-selected').forEach(function (btn) {
      const pos = parseInt(btn.dataset.option, 10);
      selectedOptions[pos] = btn.dataset.value;
    });

    const labelsEl = document.getElementById('bm-pdp-labels-json');
    const labels = labelsEl ? JSON.parse(labelsEl.textContent) : { add_to_bag: 'Add to bag', sold_out: 'Sold out' };
    
    addBtn.dataset.labelAvailable = labels.add_to_bag;
    addBtn.dataset.labelSoldOut = labels.sold_out;

    // Quantity selector interaction
    const qtyInput = document.getElementById('bm-pdp-qty-input');
    const decrementBtn = form.querySelector('.bm-qty-btn.decrement');
    const incrementBtn = form.querySelector('.bm-qty-btn.increment');

    if (qtyInput && decrementBtn && incrementBtn) {
      decrementBtn.addEventListener('click', function () {
        let val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) {
          qtyInput.value = val - 1;
        }
      });
      incrementBtn.addEventListener('click', function () {
        let val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
      qtyInput.addEventListener('change', function () {
        let val = parseInt(qtyInput.value, 10) || 1;
        if (val < 1) qtyInput.value = 1;
      });
    }

    // Scroll snap dot pagination on Mobile
    const galleryItems = document.querySelector('.bm-pdp-gallery-items');
    const dots = document.querySelectorAll('.bm-pdp-gallery-dot');

    if (galleryItems && dots.length > 0) {
      galleryItems.addEventListener('scroll', function () {
        const scrollLeft = galleryItems.scrollLeft;
        const width = galleryItems.clientWidth;
        const activeIndex = Math.round(scrollLeft / width);
        dots.forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === activeIndex);
        });
      });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          const index = parseInt(dot.dataset.index, 10);
          const item = galleryItems.children[index];
          if (item) {
            item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      });
    }

    // Sticky Add to Cart Scroll Observer
    const stickyCart = document.getElementById('bm-sticky-cart');
    const stickySubmit = document.getElementById('bm-sticky-cart-submit');

    if (stickyCart && addBtn) {
      if (stickySubmit) {
        stickySubmit.addEventListener('click', function () {
          addBtn.click(); // Programmatically trigger the main PDP Add to Bag submission
        });
      }

      // Modern IntersectionObserver for smooth 60fps scroll tracking
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          const bounding = addBtn.getBoundingClientRect();
          const scrolledPast = bounding.top < 0;

          if (entry.isIntersecting) {
            stickyCart.classList.remove('is-visible');
            stickyCart.setAttribute('aria-hidden', 'true');
          } else if (scrolledPast) {
            stickyCart.classList.add('is-visible');
            stickyCart.removeAttribute('aria-hidden');
          }
        });
      }, {
        threshold: 0
      });

      observer.observe(addBtn);
    }

    // Load Shopify Product Recommendations dynamically via AJAX fetch
    const recommendationsContainer = document.querySelector('.bm-product-recommendations');
    if (recommendationsContainer) {
      const url = recommendationsContainer.dataset.url;
      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const innerRecommendations = doc.querySelector('.bm-related-products-section');
          if (innerRecommendations) {
            recommendationsContainer.innerHTML = innerRecommendations.outerHTML;
            
            // Re-bind quick-add event listeners to the newly loaded product cards
            if (window.bmQuickAddInit) {
              window.bmQuickAddInit(recommendationsContainer);
            }
          }
        })
        .catch(function (err) {
          console.error("Error loading related products:", err);
        });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
